import Vue from 'vue'
import Vuex from 'vuex'

import unitAllData from './modules/unitAllData'
import crumbs from './modules/crumbs'
import grade from './modules/grade'
import permission from './modules/permission'
Vue.use(Vuex)
// 成绩列表数据

const store = new Vuex.Store({
  modules: {
    unitAllData,
    crumbs,
    grade,
    permission
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js